import styled from 'styled-components';

export const StyledFlexPreview = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.background};
`;

export const StyledFlexView = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const StyledModelViewer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 2vw;

  model-viewer {
    width: 100%;
    height: 100%;
  }

  #model {
    --progress-bar-color: none;
    --progress-bar-height: 0px;
  }
`;

export const LeftPanel = styled.div`
  width: 30vw;
  height: 50vh;
  position: absolute;
  bottom: 8vh;
  left: 6vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const RightPanel = styled.div`
  width: 30vw;
  height: 40vh;
  position: absolute;
  bottom: 8vh;
  right: 6vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ItemFrame = styled.div`
  height: 30%;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 2vh;
  border: solid 0.5vh ${({ theme, $empty }) => $empty ? 'white' : theme.selection };
  opacity: ${({ $empty }) => $empty ? '0.6' : '1.0'};
`;

export const ItemBg = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 2vh;
  top: 0;
  left: 0;
  object-fit: contain;
  border: solid 0.25vh black;
`;

export const ItemImage = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  object-fit: contain;
  left: 0;
`;

export const StatFrame = styled.div`
  height: 18%;
  width: 100%;
  display: flex;
  gap: 2vw;
  flex-direction: row;
`;

export const StatIcon = styled.img`
  height: 100%;
  aspect-ratio: 1/1;
`;

export const StatData = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
  text-transform: uppercase;
  color: white;
`;

export const StatName = styled.div`
  font-family: 'BebasNeue';
  font-size: 3vh;
  text-shadow: 2px 0 #000, -2px 0 #000, 0 2px #000, 0 -2px #000,
             1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000;
`;

export const StatValue = styled.div`
  font-family: 'NeueMachina';
  font-size: 5vh;
  text-shadow: 2px 0 #000, -2px 0 #000, 0 2px #000, 0 -2px #000,
             1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000;
`;

export const UserName = styled.div`
  position: absolute;
  top: 4vh;
  left: 50%;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-weight: 700;
  font-family: 'NeueMachina';
  font-size: 10vh;
  opacity: 0.6;
  text-shadow: 2px 0 #000, -2px 0 #000, 0 2px #000, 0 -2px #000,
             1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000;
`;

export const ItemEmpty = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-transform: uppercase;
  font-family: 'NeueMachina';
  font-size: 5vh;
  font-weight: 700;
  text-shadow: 2px 0 #000, -2px 0 #000, 0 2px #000, 0 -2px #000,
             1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000;
`;
